import { usePermission } from "@getsoren/design-system";
import { Navigate } from "react-router";
import ROUTES from "@/constants/routes";

/**
 * Redirect to the first accessible page based on user permissions
 * @constructor
 */
const HomeRedirect = () => {
  const { hasPermission } = usePermission();
  const hasRequests = hasPermission("requests");
  const hasDeals = hasPermission("deals");

  if (hasRequests) {
    return <Navigate to={ROUTES.requests} />;
  }

  if (hasDeals) {
    return <Navigate to={ROUTES.deals} />;
  }

  return <Navigate to={ROUTES.profile} />;
};

export default HomeRedirect;
